import { faFacebook, faLinkedin, faMailchimp, faYoutube } from '@fortawesome/free-brands-svg-icons'
import { faLocationArrow, faPhone } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export default function Footer() {
    return (
        <div className="bg-secondary mt-3 row">
            <div className="col-4 mt-2">
            <h3 className ="text-white">
                Stay Connected With Us
            </h3>
            <FontAwesomeIcon icon={faFacebook} className="text-white me-2"/>
            <FontAwesomeIcon icon={faYoutube} className="text-white me-2"/>
            <FontAwesomeIcon icon={faLinkedin} className="text-white me-2"/>
            <FontAwesomeIcon icon={faMailchimp} className="text-white me-2"/> 
            </div>
            <div className="col-4 mb-2 mt-2">
                <h3 className="text-white">
                    Address
                </h3>
                <FontAwesomeIcon icon={faPhone}className="text-white"/> <span className="text-white">
                +8801821484988 </span>  <br />
                <FontAwesomeIcon icon={faLocationArrow} className="text-white"/> 
                <span className="text-white">
                House No: 3 , Road No:2, Dhanmondi 32 , Dhaka , Bangladesh
                </span> 
            </div>
            <div className="col-4 mt-2">
                <span className="text-white">
                   <a href='#' className="text-decoration-none text-white"> Terms & Condition </a><br />
                   <a href='#' className="text-decoration-none text-white"> Cookies Policy </a><br />
                     
                </span>
            </div>
        </div>
    )
}
